export default fields => {
  if (Object.keys(fields).every(key => fields[key].changed)
    && !Object.keys(fields).some(key => fields[key].invalid)) {
    return true
  }
  return false
}
